import { createAsyncThunk } from '@reduxjs/toolkit';
import { getFetchWishListBySharingCodeApiCallMagento } from '../apis/wish-list-get-by-sharing-code.api';
import { getWishListBySharingCodeUrlMagento } from '../../../common/constants/shop-api';

export const fetchWishListBySharingCode = createAsyncThunk(
  'wishList/fetchBySharingCode',
  async (wishListSharingCode: string) =>
    await getFetchWishListBySharingCodeApiCallMagento(getWishListBySharingCodeUrlMagento(wishListSharingCode))
);
